import request from '../../../helpers/request';

const changeCameraName = async ({ cameraId, cameraName }) => {
  return await request.put(
    '/Camera',
    { cameraId, cameraName },
    'При изменении наименования камеры произошла ошибка',
    null
  );
};

export default changeCameraName;
